import { REFRESH_TIERS, type RefreshTier } from './types';

const STALE_MULTIPLIER: Record<RefreshTier, number> = {
    A: 3,
    B: 3,
    C: 2,
    D: 2,
};

export function getStaleThresholdMs(tier: RefreshTier): number {
    const cfg = REFRESH_TIERS[tier];
    return cfg.defaultMs * STALE_MULTIPLIER[tier];
}

export function getStaleThresholdLabel(tier: RefreshTier): string {
    const ms = getStaleThresholdMs(tier);
    if (ms < 1000) return `${ms}ms`;
    if (ms < 60000) return `${Math.floor(ms / 1000)}s`;
    return `${Math.floor(ms / 60000)}m`;
}

export function getAllStaleThresholds(): Record<RefreshTier, number> {
    return {
        A: getStaleThresholdMs('A'),
        B: getStaleThresholdMs('B'),
        C: getStaleThresholdMs('C'),
        D: getStaleThresholdMs('D'),
    };
}
